import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { AngularModalService } from './modal.service';
import { CompanyPageModifyPlanModalComponent } from 'src/app/pages/mission-control-page/company-page/company-page-modify-plan-modal/company-page-modify-plan-modal.component';

// Downgraded (see service.module.ajs.js) so the still-AngularJS
// company-page.component.js root controller (native port not due until
// build step 10) can open this native modal in place of its old
// `this.$uibModal.open({component: 'modifyPlanModal', ...})` call.
@Injectable({
  providedIn: 'root'
})
export class CompanyPageModifyPlanModalService {

  modifyPlanModal!: BsModalRef;

  constructor(private bsModalService: BsModalService, private angularModalService: AngularModalService) { }

  show(initialState: {
    selectedPlanName: string;
    planTypeList: any[];
    selectedPlan: any;
    futurePlan: any;
    isModifyPlan: boolean;
    isFuturePlanExists: boolean;
    isActivePlanExists: boolean;
    currentPlanEndDate: Date;
  }, onResult: (callbackObject: any) => void): void {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl';
    config.ignoreBackdropClick = true;
    config.initialState = initialState;
    this.modifyPlanModal = this.bsModalService.show(CompanyPageModifyPlanModalComponent, config);
    this.modifyPlanModal.content.onClose.subscribe((callbackObject: any) => {
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      onResult(callbackObject);
    });
  }
}
